<lib-login-logo></lib-login-logo>

<h2 class="ion-text-center ion-padding-horizontal ion-margin-top">{{ 'register.title' | translate }}</h2>
<p class="ion-text-center fs-sm ion-padding-horizontal">{{ 'register.intro' | translate }}</p>

<ion-list class="block-content-round no-padding">
  <lib-company-registration-form [form]="companyForm"></lib-company-registration-form>
  <lib-user-registration-form [form]="userForm"></lib-user-registration-form>

  @if (errorMessage()) {
    <div class="errors ion-padding">
      {{ errorMessage() }}
    </div>
  }

  @if (isDesktopView()) {
    <div class="ion-padding">
      <ion-button
        expand="block"
        fill="solid"
        size="default"
        [disabled]="isOffline()"
        (click)="doRegister()"
      >
        {{ 'register.general' | translate }}
      </ion-button>
    </div>
  }

  <ion-item lines="none">
    <ion-label class="ion-text-center fs-sm">
      <a [routerLink]="['/login']">{{ 'register.back_to_login' | translate }}</a>
    </ion-label>
  </ion-item>
</ion-list>
